module.exports = __webpack_public_path__ + "img/waiting-payment.f8a0ae6f.svg";